import type { PlainEnvironment } from "@/queries/environment-queries";

/**
 * Produces the path to the environment details page for the given environment.
 */
export function getDetailsURL(environment: PlainEnvironment): string {
    return `/details/${environment.id}`;
}
